// extracted by mini-css-extract-plugin
module.exports = {"root":"GenericCardSwiper_root__WOJB5","slider":"GenericCardSwiper_slider__XlqvM","rotation":"GenericCardSwiper_rotation__hstiT"};